<mat-paginator 
    [showFirstLastButtons]="!(showCollapsedModeSubject | async)"
    [hidePageSize]="showCollapsedModeSubject | async"
    [pageSize]="pageSize"
    [pageIndex]="pageIdxSubject | async"
    [length]="totalLengthSubject | async"
    (page)="pageIdxSubject.next($event.pageIndex)"
>
</mat-paginator>